import { fuzzySearchResults } from './closestMatchOnKeyFuzzySearchHelpers';

function phoneClosestMatchOnKeyName<T extends { key: string; value: string }>(
  data: T[]
): string | null {
  const phoneMatchTerm = 'phone';
  const backupMatchTerms = ['caller'];

  let phoneMatch = data?.find((x) => x.key.toLowerCase() === phoneMatchTerm);
  if (!phoneMatch) {
    phoneMatch = fuzzySearchResults(phoneMatchTerm, data, 50)[0]?.data ?? null;
  }
  if (phoneMatch) {
    return phoneMatch.value.toLowerCase();
  }

  let backupMatch: string | undefined;
  backupMatchTerms.forEach((term) => {
    let matchedTerm = data?.find((x) => x.key.toLowerCase() === term);
    if (!matchedTerm) {
      matchedTerm = fuzzySearchResults(term, data, 50)[0]?.data ?? null;
    }

    if (matchedTerm) {
      backupMatch = matchedTerm.value.toLowerCase();
    }
  });

  return backupMatch ?? null;
}

export default phoneClosestMatchOnKeyName;
